export default __webpack_public_path__ + "static/media/vivaldi.d0a1a930.svg";